import { render, staticRenderFns } from "./binding.vue?vue&type=template&id=434600af&scoped=true"
import script from "./binding.vue?vue&type=script&lang=js"
export * from "./binding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434600af",
  null
  
)

export default component.exports